import { Element, useEditor, useNode } from "@craftjs/core";
import { rem } from "polished";
import * as React from "react";
import { useSelector } from "react-redux";
import type { Vendor } from "src/types";

import TopLevelFloatingOptions from "@/components/editor/block-outline/floating-options/top-level-floating-component";
import Text from "@/components/editor/primitives/text/text-component";
import { BlockMaxWidthWrapper } from "@/components/editor/shared/block-wrapper";
import SyncedBoothsSettings from "@/components/editor/shared/expo/booths-settings/synced-booths-settings-component";
import { getAllVendors } from "@/features/vendors/vendors-reducer";

import BoothCard from "./booth-card/booth-card-component";
import {
  BackgroundColorWrapper,
  BoothsList,
  CenteredHeader,
  PaddingWrapper,
} from "./booths-component-styles";

type SyncedBoothsProps = {
  vendors?: Vendor[];
};

export default function SyncedBooths(props: SyncedBoothsProps) {
  const {
    connectors: { connect },
    id: nodeId,
  } = useNode();
  const dasboardVendors = useSelector(getAllVendors);
  const vendors = props.vendors ?? dasboardVendors;

  const isEmpty = vendors.length === 0;
  const { enabled } = useEditor((state) => ({
    enabled: state.isEnabled(),
  }));

  if (!enabled && isEmpty) return null;

  return (
    <BackgroundColorWrapper ref={connect} id={nodeId}>
      <PaddingWrapper>
        <BlockMaxWidthWrapper maxWidth={rem(1248)}>
          <CenteredHeader>
            <Element
              id="title"
              is={Text}
              text="Expo Booths"
              pattern="headingTwo"
            />
          </CenteredHeader>
          <BoothsList>
            {enabled && isEmpty && <SyncedBoothsSettings minimal />}
            {vendors.map((vendor) => (
              <BoothCard key={vendor.id} vendor={vendor} />
            ))}
          </BoothsList>
        </BlockMaxWidthWrapper>
      </PaddingWrapper>
    </BackgroundColorWrapper>
  );
}

SyncedBooths.craft = {
  isCanvas: true,
  custom: {
    displayName: "Synced Expo Booths",
  },
  related: {
    leftOutlineOptions: TopLevelFloatingOptions,
    settings: SyncedBoothsSettings,
  },
};
